export default __webpack_public_path__ + "static/media/ic-cover.9dd94558.svg";